(function() {
  var plus;

  plus = {
    camelize: function(string) {
      if (string) {
        return string.replace(/[_-]+(\w)/g, function(m) {
          return m[1].toUpperCase();
        });
      } else {
        return '';
      }
    },
    uncamelize: function(string) {
      if (!string) {
        return '';
      }
      return string.replace(/([A-Z])+/g, function(match, letter) {
        if (letter == null) {
          letter = '';
        }
        return "_" + (letter.toLowerCase());
      });
    },
    dasherize: function(string) {
      if (!string) {
        return '';
      }
      string = string[0].toLowerCase() + string.slice(1);
      return string.replace(/([A-Z])|(_)/g, function(m, letter) {
        if (letter) {
          return '-' + letter.toLowerCase();
        } else {
          return '-';
        }
      });
    }
  };

  module.exports = plus;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ../~/octokat/dist/node/plus.js
// module id = 758
// module chunks = 0